import { useContext } from 'react';
import { PlanoContratacaoContextData } from '../types';
import { PlanoContratacaoContext } from '../contexts/PlanoContratacaoContext';

export const usePlanoContratacao = (): PlanoContratacaoContextData =>
  useContext(PlanoContratacaoContext);
